import React from 'react';
import { Grid, Header } from 'semantic-ui-react';

import QbImg1 from 'assets/img/qbdv2_img1.png';
import QbImg2 from 'assets/img/qbdv2_img2.png';
import QbImg3 from 'assets/img/qbdv2_img3.png';
import QbImg4 from 'assets/img/qbdv2_img4.png';
import QbImg5 from 'assets/img/qbdv2_img5.png';
import QbImg6 from 'assets/img/qbdv2_img6.png';
import QbImg7 from 'assets/img/qbdv2_img7.png';

import Steps from './components/Steps';
import NavItem from '../Common/NavItem';
import StepSegment from './components/StepSegment';
import StepInception from './components/StepInception';
import ConnectButton from '../Status/components/ConnectButton';


class Setup extends React.Component {
  constructor(props) {
    super(props);
    this.state = { currentStep: 1 };
  }

  handleStepForward = () => {
    const { currentStep } = this.state;

    this.setState({ currentStep: currentStep + 1 });
  }

  handleStepBackward = () => {
    const { currentStep } = this.state;

    this.setState({ currentStep: currentStep - 1 });
  }

  handleDone = () => {

  }

  render() {
    const { currentStep } = this.state;

    const doneButton = (
      <NavItem
        className="ui primary button"
        options={ { reload: true } }
        routeName="qb.status"
      >Done
      </NavItem>
    );

    return (
      <Grid className="setup" style={ { paddingTop: 50, paddingBottom: 50 } }>
        <Grid.Column width={ 2 } />

        <Grid.Column width={ 12 }>
          <Header size="huge">Set Up Steps</Header>

          <p>Complete these 3 steps before you sync with QuickBooks.</p>

          <StepSegment
            hideBackButton
            onNextClick={ this.handleStepForward }
            title="Step 1: Getting Ready"
            visible={ currentStep === 1 }
          >
            <p>Make sure of the following before proceeding:</p>

            <ol>
              <li>Open your QuickBooks Company File in &quot;Single-User&quot; mode, as an Admin.</li>
              <li>Go through this Setup on the computer that has your QuickBooks Company File.</li>
            </ol>
          </StepSegment>

          <StepSegment
            onBackClick={ this.handleStepBackward }
            onNextClick={ this.handleStepForward }
            title="Step 2: Review Data Mapping"
            visible={ currentStep === 2 }
          >
            <p>Before proceeding, review <strong><a href="http://forum.mhelpdesk.com/quickbooks-sync/quickbooks-desktop-mapping" rel="noopener noreferrer" target="_blank">this article</a></strong> we&apos;ve prepared on how your mHelpDesk and QuickBooks accounts will sync data.</p>
          </StepSegment>

          <StepSegment
            doneButton={ doneButton }
            hideNextButton
            onBackClick={ this.handleStepBackward }
            title="Step 3: Download the Web Connector"
            visible={ currentStep === 3 }
          >
            <StepInception images={ [QbImg1] }>
              <strong>1.</strong> Click <strong><ConnectButton label="here" link /></strong> to download the QuickBooks Web Connector (.QWC) file you&apos;ll need to sync mHelpDesk and QuickBooks
            </StepInception>

            <StepInception images={ [QbImg2] }>
              <strong>2.</strong>  Open the Web Connector file you’ve downloaded, Authorize access to QuickBooks and click <strong>OK</strong>.
            </StepInception>

            <StepInception images={ [QbImg3] }>
              <strong>3.</strong> Select the <strong>third option</strong> to enable the sync to happen whenever QuickBooks is open. Click on QuickBooks to see this window.
            </StepInception>

            <StepInception images={ [QbImg4] }>
              <strong>4.</strong> Confirm access by selecting <strong>Done</strong>.
            </StepInception>

            <StepInception images={ [QbImg5] }>
              <strong>5.</strong> Enter your <strong>mHelpDesk password</strong> in the Web Connector.
            </StepInception>

            <StepInception images={ [QbImg6] }>
              <strong>6.</strong> Save your password (recommended).
            </StepInception>

            <StepInception images={ [QbImg7] }>
              <strong>7.</strong> Select your mHelpDesk account using the checkmark on the left, and click <strong>Updated Selected</strong>.
            </StepInception>

            <StepInception>
              <strong>8.</strong> Click &quot;Done&quot; below to conclude Setup and be sent to the Status page!
            </StepInception>
          </StepSegment>

          <Steps currentStep={ currentStep } />
        </Grid.Column>
      </Grid>
    );
  }
}

export default Setup;



// WEBPACK FOOTER //
// ./src/components/Setup/index.js